import imageCompression from 'browser-image-compression';

const imageTobase64 = async(image) =>{
    if (!image) return null;

    let fileToProcess = image;

    // Optional: Compress if it's a File and over 500KB (for profile pics)
    if (image instanceof File && image.size > 500 * 1024) {
        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 800,
            useWebWorker: true,
        };
        try {
            fileToProcess = await imageCompression(image, options);
        } catch (error) {
            console.error("Compression failed, using original image", error);
        }
    }

    const reader = new FileReader()
    reader.readAsDataURL(fileToProcess)

    const data = await new Promise((resolve,reject)=>{
        reader.onload = () => resolve(reader.result)

        reader.onerror = error => reject(error)
    })

    return data
}

export default imageTobase64;